<template>
  <div class="upload-modal">
    <v-dialog v-model="dialog" class="uploader">
      <template v-slot:activator="{ on, attrs }">
        <div class="text-xs-center">
          <v-btn
            color="red lighten-2 text-center"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Upload Image
          </v-btn>
        </div>
      </template>

      <v-card ref="croppieCard">
        <v-card-title class=""> File Upload </v-card-title>

        <v-card-text>
          <form v-show="isInitial">
            <div class="dropbox">
              <h2 class="text-center pt-3">
                Drag a file or click to upload a file
              </h2>
              <input
                type="file"
                name="uploadFieldName"
                ref="fileUploader"
                @change="filesChange($event.target.files)"
                accept="image/*"
                class="input-file"
              />
            </div>
          </form>
          <v-container
            fill-height
            v-show="isCropping"
            class="cropping-container"
          >
            <v-row class="pt-5">
              <v-col cols="12">
                <div ref="croppieContainer"></div>

                <div class="croppieLoader" ref="croppieLoader">
                  <LoadingBar />
                </div>

                <v-row class="pt-5">
                  <v-col cols="6">
                    <div class="text-center">
                      <v-select
                        :items="sizes"
                        label="Image Size"
                        outlined
                        @input="changeSize"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="text-center">
                      <v-btn color="lighten-2" text @click="rotateLeft">
                        Rotate Left
                      </v-btn>
                      <v-btn color="lighten-2" text @click="rotateRight">
                        Rotate Right
                      </v-btn>
                    </div></v-col
                  >
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-card-actions v-show="isCropping">
                  <v-col class="text-right">
                    <v-btn
                      color="green lighten-2"
                      ref="saveButton"
                      text
                      @click="getResult"
                    >
                      Save
                    </v-btn>
                    <v-btn color="red lighten-2" text @click="reset">
                      Cancel
                    </v-btn>
                  </v-col>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import "croppie/croppie.css";
import Croppie from "croppie/croppie.js";
import firebase from "firebase/app";
import "firebase/storage";

export default {
  components: {
    LoadingBar: () => import("../../LoadingBar.vue"),
  },
  props: {
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
    resize: {
      type: Boolean,
      default: false,
    },
    path: {
      type: String,
    },
  },
  data: () => ({
    croppieObject: Object,
    file: {
      name: "",
      type: "",
    },
    fileList: {},
    sizes: [
      { text: "THUMBNAIL (100X100)", value: { x: 100, y: 100 } },
      { text: "LARGE (480X480)", value: { x: 480, y: 480 } },
      { text: "BANNER (1000X600)", value: { x: 1000, y: 600 } },
      { text: "LARGE BANNER (1600X600)", value: { x: 1600, y: 600 } },
    ],
    imgWidth: 0,
    imgHeight: 0,
    croppingSRC: "",
    dialog: false,
    isInitial: true,
    isCropping: false,
    isSuccess: false,
  }),
  mounted() {
    console.log(this.$props.path);

    this.$props.width;
    this.$props.height;
  },
  watch: {
    dialog: function (newValue, old) {
      if (!newValue) {
        this.reset();
      }
    },
  },
  methods: {
    changeSize(event) {
      this.croppieObject.destroy();
      this.croppieObject = null;
      this.$props.width = event.x;
      this.$props.height = event.y;
      this.filesChange(this.fileList);
    },
    async filesChange(fileList) {
      try {
        this.croppieObject.destroy();
      } catch (err) {}
      this.croppieObject = null;
      this.isInitial = false;
      this.isCropping = true;

      let self = this;

      if (!fileList.length) return;
      this.fileList = fileList;

      Array.from(Array(fileList.length).keys()).map((x) => {
        const objectURL = URL.createObjectURL(fileList[x]);
        self.croppingSRC = objectURL;
        self.file = fileList[x];

        // if (!this.croppieObject.data) {
        this.croppieObject = new Croppie(this.$refs.croppieContainer, {
          viewport: {
            width: self.$props.width,
            height: self.$props.height,
          },
          boundary: {
            width: self.$props.width,
            height: self.$props.height,
          },
          showZoomer: true,
          enableResize: false,
          enableOrientation: true,
        });
        // }
        self.croppieObject.bind({
          url: self.croppingSRC,
          zoom: 0,
        });
      });

      if (this.resize) {
        this.$refs.croppieContainer.style.opacity = 0;
        this.$refs.croppieLoader.style.opacity = 1;
        this.$refs.croppieLoader.style.display = "block";
        setTimeout(function () {
           self.getResult();
        }, 1000);
      }
    },
    rotateLeft() {
      this.croppieObject.rotate(90);
    },
    rotateRight() {
      this.croppieObject.rotate(-90);
    },
    getResult() {
      let self = this;
      var storageRef = firebase.storage().ref();
      this.croppieObject.result("base64").then((html) => {
        var imageRef = storageRef.child(
          "/" + self.$props.path + "/" + Math.floor(Math.random() * (new Date().getTime() / 1000 - 0) + 0) + self.file.name 
        );
        imageRef.putString(html, "data_url").then((snapshot) => {
          snapshot.ref.getDownloadURL().then((downloadURL) => {
            self.file = downloadURL;
            this.$parent.$emit("uploadDone", { url: downloadURL });
          });
        });
        this.reset();
      });
    },
    reset() {
      this.croppieObject.bind({
        url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=",
      });
      this.$refs.fileUploader.value = "";
      this.dialog = false;
      this.croppingSRC = "";
      this.isInitial = true;
      this.isCropping = false;
      this.isSuccess = false;
    },
  },
};
</script>
<style lang="scss">
// .upload-modal {
.croppie-container {
  height: auto !important;
  width: auto !important;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  justify-content: center;

  -webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  -webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
}

.croppieLoader {
  opacity: 0;
  display: none;
  position: absolute;
  z-index: 9999;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  color: dimgray;
  padding: 10px 10px;
  min-height: 75vh; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
// }
</style>
